import { BigTicket } from "./bigTicket/BigTicket";

/** v1 — Big Ticket: guess what enormous things cost. */
export function ValDailyV1() {
  return <BigTicket />;
}
